import { getApiUrl, apiConfig } from './environment';

// URLs completas para os endpoints
export const endpoints = {
  companyInterest: getApiUrl('/interestsubmission/company'),
  coffeeShopInterest: getApiUrl('/interestsubmission/coffee-shop')
};

// Configurações de timeout e retry
export const apiSettings = {
  timeout: apiConfig.timeout,
  retryAttempts: apiConfig.retryAttempts,
  retryDelay: apiConfig.retryDelay
};

export { apiConfig };
export default apiConfig;
